import React, { useEffect } from "react";

const SafeScreen = ({ children, className = "", style = {} }) => {
	useEffect(() => {
		const setVh = () => {
			const vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty("--vh", `${vh}px`);
		};
		setVh();
		window.addEventListener("resize", setVh);
		window.addEventListener("orientationchange", setVh);
		return () => {
			window.removeEventListener("resize", setVh);
			window.removeEventListener("orientationchange", setVh);
		};
	}, []);

	return (
		<div
			className={className}
			style={{
				height: "calc(var(--vh, 1vh) * 100)",
				paddingTop: "env(safe-area-inset-top)",
				paddingBottom: "env(safe-area-inset-bottom)",
				width: "100%",
				boxSizing: "border-box",
				display: "flex",
				flexDirection: "column",
				...style,
			}}
		>
			{children}
		</div>
	);
};

export default SafeScreen;
